import type { SliceRouteContract } from '@/shared/lib/vsa';
import { ProductsSlicePage } from './ProductsSlicePage';
import { ProductsChainsSlicePage } from './ProductsChainsSlicePage';

export const productsRouteContract: SliceRouteContract = {
  routeId: 'products',
  component: ProductsSlicePage,
};

export const productsChainsRouteContract: SliceRouteContract = {
  routeId: 'products-chains',
  component: ProductsChainsSlicePage,
};
